import React from 'react';
import PropTypes from 'prop-types';

import { Button, Tooltip } from '@telus-uds/components-web';
import Delete from '@telus-uds/palette-allium/build/web/icons/Delete';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const DevicesTable = ({ devices, onDelete }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    devicesTable: { deviceLabel, priceLabel, quantityLabel, deleteLabel },
    formButtons: { deleteButtonLabel },
    ORDERS: { labelTotalDevices }
  } = localizedStrings;
  const totlDevices = devices.reduce((acc, item) => acc + +item.quantity, 0);

  return (
    <div className="responsive-table-container" style={{ margin: '2rem 0' }}>
      <table className="responsive-table">
        <caption className="responsive-table__caption">
          {`${labelTotalDevices} (${totlDevices})`}
        </caption>
        <thead className="responsive-table__thead">
          <tr>
            <th>#</th>
            <th>{deviceLabel}</th>
            <th>{priceLabel}</th>
            <th>{quantityLabel}</th>
            <th>{deleteLabel}</th>
          </tr>
        </thead>
        <tbody className="responsive-table__tbody">
          {devices.map((item, index) => {
            const { name: device, unitPrice, quantity } = item;
            const rowKey = `row${index}`;

            return (
              <tr key={rowKey}>
                <td data-header-label="#">{index + 1}</td>
                <td data-header-label={deviceLabel}>{device}</td>
                <td data-header-label={priceLabel}>{`$${unitPrice}`}</td>
                <td data-header-label={quantityLabel}>{quantity}</td>
                <td data-header-label={deleteLabel}>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Tooltip content={deleteButtonLabel}>
                      <Button
                        icon={Delete}
                        accessibilityLabel={deleteButtonLabel}
                        onPress={() => onDelete(index)}
                        variant={{ text: true }}
                      />
                    </Tooltip>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

DevicesTable.propTypes = {
  devices: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      unitPrice: PropTypes.number,
      quantity: PropTypes.number
    })
  ).isRequired,
  onDelete: PropTypes.func.isRequired
};

export default DevicesTable;
